import gql from 'graphql-tag';
import _, { get } from 'lodash';
import { compose, graphql } from 'react-apollo';
import { parseJsonFields } from '../../../services/parseApiService.js';
import { queryTieredBonusesByCompanyIdIndex } from '../../graphql/custom/tiered-bonuses';

export const withListTieredBonus = (Component) => {
	return compose(
		graphql(gql(queryTieredBonusesByCompanyIdIndex), {
			options: (props) => ({
				context: {
					headers: {
						'x-frame-options': 'deny', // This header will reach the server
					},
				},
				variables: {
					companyId: props.currentUser.companyId,
					first: 1000,
					after: null,
				},
				fetchPolicy: 'cache-first',
			}),
			props(props) {
				const bonusesNextToken = get(
					props,
					'data.queryTieredBonusesByCompanyIdIndex.nextToken',
					null
				);
				const onFetchMoreBonuses = makeOnFetchMoreBonuses(
					props.data.fetchMore,
					bonusesNextToken
				);
				if (
					!props.data.loading &&
					(!props.data.queryTieredBonusesByCompanyIdIndex || props.data.error)
				) {
					setTimeout(props.data.refetch, 2000);
					return null;
				}

				let bonuses = get(props, 'data.queryTieredBonusesByCompanyIdIndex.items', []);
				if (bonuses) {
					bonuses = bonuses.map(bonus => 
						Object.assign(bonus, parseJsonFields(['tiers'], bonus))
					);

					bonuses = bonuses.filter(bonus => !bonus.archived);
					bonuses = _.orderBy(bonuses, ['name'], ['asc']);
				} else {
					bonuses = [];
				}

				if (bonusesNextToken) onFetchMoreBonuses();
				return {
					bonuses,
				};
			},
		})
	)(Component);
};

const makeOnFetchMoreBonuses = (fetchMore, nextToken) => {
	if (!nextToken) {
		return null;
	}

	return () => {
		fetchMore({
			variables: { after: nextToken },
			updateQuery(previous, { fetchMoreResult }) {
				if (!fetchMoreResult) {
					return previous;
				}

				const mergedItems = [
					...previous.queryTieredBonusesByCompanyIdIndex.items,
					...fetchMoreResult.queryTieredBonusesByCompanyIdIndex.items,
				];
				const set = new Set();
				const uniqueItems = mergedItems.filter((item) => {
					if (!set.has(item.id)) {
						set.add(item.id);
						return true;
					}

					return false;
				});
				return {
					...previous,
					queryTieredBonusesByCompanyIdIndex: {
						...previous.queryTieredBonusesByCompanyIdIndex,
						...fetchMoreResult.queryTieredBonusesByCompanyIdIndex,
						items: uniqueItems,
					},
				};
			},
		});
	};
};
